import styles from "@/components/common/styles/checkbox.module.scss";
import React from "react";

type CheckBoxProps = {
  isChecked: boolean;
  onChange: () => void;
  isEnabled?: boolean;
};

const CheckBox = ({ isChecked, onChange, isEnabled = true }: CheckBoxProps) => {
  return (
    <div className={styles.checkbox_wrapper}>
      <input
        className={styles.checkbox}
        style={{ cursor: isEnabled ? "pointer" : "not-allowed" }}
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
        disabled={!isEnabled}
      />
    </div>
  );
};

export default CheckBox;
